export default "__VITE_ASSET__40dadd95__"